import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, NavLink, Outlet, useLocation } from 'react-router-dom';
import { APP_LINKS } from '@/helpers/links';
import { APP_MODES } from '@/helpers/constants';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { useUserStore } from '@/store/userStore';
import './index.scss';

const TABS = t => [
  {
    label: t('payment_tabs.next_repayment'),
    path: APP_LINKS.nextPayment,
  },
  {
    label: t('payment_tabs.add_funds'),
    path: APP_LINKS.addFunds,
  },
  {
    label: t('payment_tabs.withdraw'),
    path: APP_LINKS.withdraw,
  },
  {
    label: t('payment_tabs.bank_accounts'),
    path: APP_LINKS.bankAccounts,
  },
];

const LENDER_SPLIT_HIDDEN_TABS = [APP_LINKS.nextPayment, APP_LINKS.bankStatements];

const PaymentsPage = () => {
  const location = useLocation();
  const { t } = useTranslation('common');
  const mode = useUserStore(state => state.mode);
  const { isLender } = useGetMe();

  const isSplitModeLender = mode === APP_MODES.split && isLender;
  const tabs = useMemo(
    () =>
      TABS(t).filter(
        tab => !isSplitModeLender || !LENDER_SPLIT_HIDDEN_TABS.includes(tab.path),
      ),
    [isSplitModeLender, t],
  );

  const defaultPath = tabs[0]?.path;
  const shouldRedirect =
    defaultPath &&
    (location.pathname === APP_LINKS.payments ||
      (isSplitModeLender && LENDER_SPLIT_HIDDEN_TABS.includes(location.pathname)));

  if (shouldRedirect) return <Navigate to={defaultPath} replace />;

  return (
    <div className="payments-page">
      <div className="container-inner">
        <h1 className="payments-page__title f-500 f-42">{t('payments_page.title')}</h1>
        <div className="payments-page__links">
          {tabs.map(tab => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `payments-page__link ${isActive ? 'payments-page__link-selected' : ''}`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default PaymentsPage;
